<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon fab @click="downloadTable">
        <v-icon :color="dark ? 'white' : ''" v-bind="attrs" v-on="on">
          mdi-download
        </v-icon></v-btn
      >
    </template>
    <span>Export to Excel</span>
  </v-tooltip>
</template>

<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  mounted() {},
  props: {
    datos: {
      type: Array,
      default: () => [["hello", "world"]]
    },
    filename: {
      type: String,
      default: "filename"
    },
    sheetname: {
      type: String,
      default: "sheetname"
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    idFilename() {
      const datenow = Date.now();
      return datenow;
    },

    downloadTable() {
      const wb = XLSX.utils.book_new();
      wb.Props = {
        Title: this.sheetname,
        Author: "METAX TECHNOLOGIE",
        CreatedDate: new Date()
      }; // Datos basicos del excell
      wb.SheetNames.push(this.sheetname); // nombre de la hoja
      const ws_data = this.datos; //datos deben ser un array de array, filas primero, columnas segundo e.j.  [['hello' , 'world']] 2 col, 1 row
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      let objectMaxLength = [];
      this.datos.map(arr => {
        Object.keys(arr).map(key => {
          let value = arr[key] === null ? "" : arr[key];

          if (typeof value === "number") {
            return (objectMaxLength[key] = 10);
          }

          objectMaxLength[key] =
            objectMaxLength[key] >= value.length
              ? objectMaxLength[key]
              : value.length;
        });
      });
      let worksheetCols = objectMaxLength.map(width => {
        return {
          width
        };
      });
      ws["!cols"] = worksheetCols;
      wb.Sheets[this.sheetname] = ws;
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const filename = `${this.filename}${this.idFilename()}.xlsx`;

      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        filename
      );
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    }
  }
};
</script>

<style></style>
